module.exports = __webpack_public_path__ + "img/empty_messages.69040e9e.svg";